import React, { useEffect, useState, Fragment } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, Bell } from 'lucide-react';
interface Props {
  onRestart: () => void;
}
const lines = ['ERA is happening now.', 'We’re bringing the science, stories, and people back with us.'];
export const Screen7Input = ({
  onRestart
}: Props) => {
  const [lineIndex, setLineIndex] = useState(0);
  useEffect(() => {
    if (lineIndex < lines.length - 1) {
      const t = setTimeout(() => setLineIndex(lineIndex + 1), 2500);
      return () => clearTimeout(t);
    }
  }, [lineIndex]);
  return <div className="relative w-full h-full overflow-hidden bg-black flex flex-col" data-id="element-624">
      {/* Background Video Montage */}
      <div className="absolute inset-0" data-id="element-625">
        <video src="https://cdn.magicpatterns.com/uploads/vNhaE8sRKqw4ChzivnuwFr/coffee.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover opacity-80" data-id="element-626" />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/20 to-black/80" data-id="element-627" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-red-700/30 rounded-full blur-[100px]" data-id="element-628" />

      <div className="relative z-10 flex-1 flex flex-col justify-end p-8 pb-12" data-id="element-629">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-red-500 font-semibold mb-6" data-id="element-630">
          07 — Stay Connected
        </motion.span>

        <div className="min-h-[120px]" data-id="element-631">
          <AnimatePresence mode="wait" data-id="element-632">
            <motion.h2 key={lineIndex} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -20
          }} transition={{
            duration: 0.7,
            ease: 'easeOut'
          }} className="text-3xl font-bold text-white leading-tight tracking-tight" data-id="element-633">
              {lines[lineIndex]}
            </motion.h2>
          </AnimatePresence>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: lineIndex === lines.length - 1 ? 1 : 0,
        y: lineIndex === lines.length - 1 ? 0 : 20
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-8 space-y-4" data-id="element-634">
          <button className="w-full bg-red-600 hover:bg-red-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 shadow-[0_10px_40px_rgba(220,38,38,0.4)] active:scale-[0.98] transition-all" data-id="element-635">
            <Bell className="w-5 h-5" data-id="element-636" />
            <span className="text-lg" data-id="element-637">Follow Inside Access</span>
          </button>

          <button onClick={onRestart} className="w-full text-slate-400 hover:text-white text-sm py-2 transition-colors" data-id="element-638">
            Restart experience
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: lineIndex === lines.length - 1 ? 1 : 0
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="mt-10 flex items-center justify-center space-x-3" data-id="element-639">
          {['Attract', 'Retain', 'Mobilize'].map((word, i) => <Fragment key={word} data-id="element-640">
              <span className="text-[10px] font-semibold tracking-[0.2em] uppercase text-slate-500" data-id="element-641">
                {word}.
              </span>
              {i < 2 && <span className="w-1 h-1 rounded-full bg-red-500/50" data-id="element-642" />}
            </Fragment>)}
        </motion.div>
      </div>
    </div>;
};